import React from "react";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonIcon,
  IonMenuToggle,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { menu } from "ionicons/icons";
import { CategorieLinks } from "../../components/CategorieLinks/CategorieLinks";
import { Link } from "react-router-dom";
import MasonryGrid from "../../components/MasonryGrid/MasonryGrid";

const array = () => {
  const result: string[] = [];
  for (var i = 1; i < 20; i++) {
    result.push(i < 10 ? `0${i}` : `${i}`);
  }
  return result;
};

const Examples = () => (
  <IonPage>
    <IonToolbar color="primary">
      <IonButtons slot="start">
        <IonMenuToggle>
          <IonIcon icon={menu} style={{ fontSize: 28 }} />
        </IonMenuToggle>
      </IonButtons>
      <IonTitle>Primeri radova</IonTitle>
      <IonButtons slot="end">
        <Link to={{ pathname: "/slike" }}>
          <IonButton color="dark">Motivi</IonButton>e
        </Link>
      </IonButtons>
    </IonToolbar>
    <IonContent>
      <MasonryGrid
        columns={4}
        mobileColumns={1}
        breakpoint={768}
        className="examples-masonry"
      >
        {array().map((n) => (
          <img
            key={n}
            src={`assets/examples/example_${n}.jpg`}
            alt="Example"
          />
        ))}
      </MasonryGrid>
      <CategorieLinks />
    </IonContent>
  </IonPage>
);

export default Examples;
